import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';
import moment from 'moment';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';

@Component({
    selector: 'person',
    templateUrl: './person.component.html',
    styleUrls: ['./person.component.scss'],
    providers: [DynamicContentService],
    standalone: false
})
export class PersonComponent implements OnInit {

  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;
  @Input() translationEntries;
  @Input() lang;
  @Input() orientation: any;
  @Input() create: any;

  houses = [];
  categories: Models.DynamicContentCategory[] = [];

  hideEmptyFields = true;
  showToggle = false;

  fields = ['salutation', 'lastname', 'firstname', 'department', 'house', 'floor', 'room', 'job', 'phone', 'email', 'birthday', 'order', 'categories', 'note'];
  showFields = {};

  constructor(private dynamicContentService: DynamicContentService) {
  }

  async ngOnInit() {
    if (this.dynamicContent.content.order === 0) {
      this.dynamicContent.content.order = null;
    }
    this.hideEmptyFields = !this.create;
    if (this.orientation && this.orientation.location) {
      for (const key of Object.keys(this.orientation.location)) {
        this.houses.push({ code: key, name: this.orientation.location[key].name });
      }
    }
    if (this.parent?.categories?.length) {
      this.categories = (await this.dynamicContentService.find(0, 100, { type: 'category', _id: { $in: this.parent.categories } })).data
    }
    if (!this.create) {
      this.switchHideEmptyFields();
    } else {
      this.hideEmptyFields = true;
      this.switchShowAllFields();
    }
  }

  switchShowAllFields() {
    if (this.parent.config && this.parent.config.defaultFields && this.parent.config.defaultFields.length) {
      this.showToggle = true;
      for (const field of this.fields) {
        this.showFields[field] = !this.parent.config.defaultFields.includes(field);
      }
    } else {
      this.showToggle = false;
      this.hideEmptyFields = false;
      this.switchHideEmptyFields();
    }
  }

  checkDate(event: any) {
    if (/\d\d?\.\d\d?\.\d\d\d?\d?/.test(event.target.value)) {
      this.dynamicContent.content.birthday = moment(event.target.value, 'DD.MM.YYYY').format('YYYY-MM-DD') + 'T00:00:00.000Z';
    } else {
      this.dynamicContent.content.birthday = moment(event.target.value).format('YYYY-MM-DD') + 'T00:00:00.000Z';
    }
  }

  switchHideEmptyFields() {
    for (const field of this.fields) {
      this.showFields[field] = !!this.dynamicContent.content[field];
      if (field === 'categories') {
        this.showFields[field] = this.dynamicContent.content.categories && this.dynamicContent.content.categories.length > 0;
      }
    }
  }
}
